// DS: C33A
/** Bottom section of a thumb, containing related information */ import React, { useContext } from 'react';
import classnames from 'classnames';
import Flex from '@wix/da-ds/pkg/Flex';
import UserAvatar from '../User/Avatar';
import UserLink from '../User/Link';
import DeviationLink from '../Duperbrowse/DeviationLink';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import s from './ThumbInfo.scss';
const AVATAR_SIZE_DESKTOP = 32;
const AVATAR_SIZE_MOBILE = 24;
const ThumbInfo = ({ user, title, urlDeviation })=>{
    const isMobile = useContext(MobileContext);
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], title ? s['with-title'] : s['without-title'])
    }, (!title || !isMobile) && /*#__PURE__*/ React.createElement(UserAvatar, {
        size: isMobile ? AVATAR_SIZE_MOBILE : AVATAR_SIZE_DESKTOP,
        user: user,
        className: s['avatar']
    }), !title && /*#__PURE__*/ React.createElement(UserLink, {
        user: user,
        className: s['username'],
        biData: {
            creatorid: user.useridUuid
        }
    }), title && /*#__PURE__*/ React.createElement("div", {
        className: s['info']
    }, /*#__PURE__*/ React.createElement(DeviationLink, {
        className: s['title'],
        deviation: urlDeviation
    }, title), /*#__PURE__*/ React.createElement(Flex, {
        className: s['secondRow'],
        alignItems: "center"
    }, isMobile && /*#__PURE__*/ React.createElement(UserAvatar, {
        size: AVATAR_SIZE_MOBILE,
        user: user,
        className: s['avatar']
    }), /*#__PURE__*/ React.createElement(UserLink, {
        user: user,
        className: s['username'],
        biData: {
            creatorid: user.useridUuid
        }
    }))));
};
ThumbInfo.displayName = 'ThumbInfo';
export default ThumbInfo;

//# sourceMappingURL=ThumbInfo.js.map